import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M109.16 50.3099C109.16 50.3099 109.49 42.88 106.02 38.59C102.55 34.3 99.74 35.95 99.25 30.99C98.75 26.04 96.9399 14.9699 87.8599 13.8199C87.8599 13.8199 83.82 7.31995 73.93 6.44995C63.35 5.51995 65.21 1 56.98 1C49.5 1 50.43 5.82992 39.22 6.28992C29.2 6.70992 26.1 13.8199 26.1 13.8199C17.02 14.9799 15.2 26.04 14.71 30.99C14.21 35.94 11.41 34.29 7.93996 38.59C4.46996 42.88 4.79995 50.3099 4.79995 50.3099C-3.13005 64.5099 6.44997 73.4299 6.44997 73.4299C5.12997 77.2299 7.76995 80.86 7.76995 80.86C10.25 71.28 16.42 73.92 23.46 68.64C32.05 62.2 27.42 44.36 38.98 36.11C45.88 31.18 55.82 34.13 57.09 34.13C58.36 34.13 68.08 31.19 74.98 36.11C86.54 44.37 81.92 62.2 90.5 68.64C97.54 73.92 103.71 71.28 106.19 80.86C106.19 80.86 108.83 77.2299 107.51 73.4299C107.51 73.4199 117.08 64.5099 109.16 50.3099Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M84.3899 54.6C84.3899 54.6 86.0499 62.53 92.3199 64.51C98.8199 66.56 106.82 68.6699 107.49 75.4399"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M80.2 41.5499C80.2 41.5499 82.8999 43.6999 89.9999 41.0499C97.0999 38.4099 108.5 44.1899 111.3 54.9199"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M81.4199 45.0199C81.4199 45.0199 82.4099 46.3399 89.1799 45.5199C95.9499 44.6999 109.33 45.1899 112.13 59.5599"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M66.8799 33.13C66.8799 33.13 75.7999 34.12 78.9399 26.85C82.0799 19.58 83.8899 10.8299 91.1599 14.7899"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M62.75 33.2999C62.75 33.2999 70.51 31.4799 74.64 22.5699C78.77 13.6499 84.38 11.3399 86.86 11.6699"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M70.6599 6.13C70.6599 6.13 64.7799 6.45991 64.1199 17.0299C63.4599 27.5999 63.19 31.6599 59.45 33.7999"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M29.5599 54.6C29.5599 54.6 28.3799 62.4699 21.1899 64.6599C14.8999 66.5799 7.06991 69.08 6.40991 75.85"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M34.0799 41.3299C34.0799 41.3299 31.0499 43.6999 23.9499 41.0499C16.8499 38.3999 5.4499 44.1899 2.6499 54.9199"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M32.5301 45.0199C32.5301 45.0199 31.5401 46.3399 24.7701 45.5199C18.0001 44.6999 4.62007 45.1899 1.82007 59.5599"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M47.07 33.13C47.07 33.13 38.15 34.12 35.01 26.85C31.87 19.58 30.06 10.8299 22.79 14.7899"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M51.1901 33.2999C51.1901 33.2999 43.4301 31.4799 39.3001 22.5699C35.1701 13.6499 29.5601 11.3399 27.0801 11.6699"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M44.2 5.65991C44.2 5.65991 49.4899 6.5899 50.2699 17.6499C51.0099 28.2099 52.4199 32.1699 55.5599 34.1499"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M28.0821 92.978C28.7222 91.9767 29.1489 90.8196 29.3676 89.6296C29.5738 89.3622 29.7702 89.088 29.9563 88.8038C29.9107 89.2124 29.8419 89.6194 29.7517 90.0324C29.5034 91.1493 29.0664 92.2367 28.4091 93.1852C27.7506 94.1352 26.8837 94.9366 25.9131 95.521C24.9326 96.1054 23.8384 96.4787 22.7278 96.7105L22.7278 96.7105L22.7249 96.7111C22.0164 96.8634 21.2922 96.9562 20.5671 96.985C21.2872 96.9135 21.9997 96.7837 22.6943 96.6043C24.8576 96.0529 26.8847 94.8757 28.0821 92.978ZM18.8206 92.3064C17.7666 91.949 16.8177 91.3559 16.0133 90.6105C16.8639 91.2997 17.8337 91.8265 18.8807 92.1301L18.8836 92.1309C21.0004 92.7312 23.3564 92.5623 25.2452 91.4C26.5573 90.6494 27.6691 89.5116 28.5268 88.2457C28.5092 88.568 28.4751 88.8909 28.4246 89.2113C28.3166 89.3463 28.2055 89.4802 28.0913 89.6135C27.3434 90.4762 26.4578 91.2359 25.4568 91.7931L25.4568 91.7931L25.4539 91.7947C23.451 92.9272 20.9525 93.0549 18.8256 92.3081L18.8257 92.3081L18.8206 92.3064ZM29.5394 87.56C29.538 87.4788 29.5357 87.3978 29.5325 87.317L29.6606 87.3341C29.6209 87.4103 29.5805 87.4855 29.5394 87.56ZM29.6043 86.3177L29.8882 85.7207L29.9513 86.3641L29.6043 86.3177Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M83.8737 87.5812C83.8322 87.5062 83.7914 87.4304 83.7513 87.3539L83.88 87.3367C83.877 87.418 83.8749 87.4995 83.8737 87.5812ZM83.6584 90.0523C83.5681 89.6388 83.4993 89.2301 83.4536 88.8198C83.6412 89.1071 83.8393 89.3845 84.0476 89.6551C84.2653 90.8422 84.6883 91.9971 85.3275 92.9972C86.5165 94.898 88.5561 96.0636 90.7144 96.624L90.715 96.6241C91.3984 96.8007 92.0996 96.9303 92.8086 97.0036C92.0949 96.9733 91.3825 96.881 90.6851 96.7311L90.6822 96.7305C89.5737 96.4992 88.4887 96.1262 87.4968 95.5409C86.5135 94.9448 85.6488 94.1533 85.0029 93.2079L85.003 93.2079L85.001 93.2052C84.3437 92.2567 83.9067 91.1691 83.6584 90.0523ZM87.9533 91.8131C86.9523 91.256 86.0667 90.4962 85.3188 89.6335C85.2065 89.5024 85.0971 89.3705 84.9907 89.2372C84.9404 88.9182 84.9062 88.5967 84.888 88.2755C85.7423 89.5372 86.8491 90.6714 88.1654 91.4203C90.0554 92.5831 92.4109 92.7404 94.5243 92.1516L94.5265 92.151C95.5534 91.8598 96.5015 91.3516 97.3354 90.6869C96.5442 91.4058 95.6168 91.978 94.5895 92.3264L94.5895 92.3264L94.5845 92.3282C92.4576 93.0749 89.9591 92.9473 87.9562 91.8147L87.9533 91.8131ZM83.4588 86.3841L83.5219 85.7407L83.8058 86.3377L83.4588 86.3841Z"
        fill={outline}
        stroke={outline}
      />
    </g>
  )
}
